import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"
import Tribute from "tributejs"

// Connects to data-controller="mentions"
export default class extends Controller {
  static values = { users: Array }

  connect() {
    this.setup = this.setup.bind(this)

    // Listen for Lexical editor ready event
    this._onLexicalInit = (event) => {
      if (this.element.contains(event.detail?.element || event.target)) this.setup()
    }
    document.addEventListener("lexical:initialize", this._onLexicalInit)

    // Also keep trix-initialize support for any remaining Trix usage
    this._onTrixInit = (event) => {
      if (this.element.contains(event.target)) this.setup()
    }
    document.addEventListener("trix-initialize", this._onTrixInit)

    this.setup()
  }

  disconnect() {
    document.removeEventListener("lexical:initialize", this._onLexicalInit)
    document.removeEventListener("trix-initialize", this._onTrixInit)
    if (this.tribute && this.editor) this.tribute.detach(this.editor)
  }

  setup() {
    // Try Lexical editor first — find the contenteditable div it creates
    const lexicalContainer = this.element.querySelector('[data-controller*="lexical-editor"]')
    if (lexicalContainer) {
      const lexicalCtrl = this.application.getControllerForElementAndIdentifier(lexicalContainer, "lexical-editor")
      this.editor = lexicalCtrl?.getEditorElement() || lexicalContainer.querySelector('[contenteditable="true"]')
    }

    // Fall back to legacy trix-editor element
    if (!this.editor) {
      if (this.element.tagName === "TRIX-EDITOR") {
        this.editor = this.element
      } else {
        this.editor = this.element.querySelector("trix-editor")
      }
    }

    if (!this.editor) return
    if (this.tribute) return

    const values = Array.isArray(this.usersValue) ? this.usersValue : []

    this.tribute = new Tribute({
      trigger: "@",
      values,
      lookup: (item) => `${item.value} ${item.email}`,
      fillAttr: "value",
      selectTemplate: (item) => `@${item.original.value}`,
      menuItemTemplate: (item) => {
        const name = item.original.value || ""
        const email = item.original.email || ""
        return `<div class="tribute-item"><strong>${name}</strong>${email ? ` <small>${email}</small>` : ""}</div>`
      },
      noMatchTemplate: () => `<span class="px-2 py-1 text-xs text-gray-500">${t("javascript.controllers.mentions_controller.no_matching_users")}</span>`,
    })

    this.tribute.attach(this.editor)
  }

  handleMention(event) {
    console.debug("Mention selected", event.detail)
  }
}
